import { ScatterplotLayer } from '@deck.gl/layers';
import type { LayerState, LayerFeature } from '@vitals/shared';
import { LAYER_CAMS } from '@vitals/shared';
import type { RendererDef } from './registry.js';

export function buildCamsLayer(
  state: LayerState | undefined,
  _nowSec: number,
): ScatterplotLayer<LayerFeature> | null {
  if (!state || state.status !== 'ok' || state.features.length === 0) return null;

  return new ScatterplotLayer<LayerFeature>({
    id: LAYER_CAMS,
    data: state.features as LayerFeature[],
    getPosition: (f: LayerFeature) =>
      (f.geometry as { coordinates: [number, number] }).coordinates,
    getFillColor: [255, 210, 120],
    radiusMinPixels: 2.5,
    filled: true,
    stroked: true,
    getLineColor: [255, 255, 255],
    lineWidthMinPixels: 1,
    pickable: true,
  });
}

export const camsRenderer: RendererDef = {
  layerId: LAYER_CAMS,
  build: (state, nowSec) => buildCamsLayer(state, nowSec),
};
